import type { AriaProperties, AriaPropertiesWithId } from './ariaProperties';

function joinListOfTokens(tokens: any[] | any) {
    if (Array.isArray(tokens)) {
        return tokens.join(' ');
    } else {
        return tokens;
    }
}

export function generateDomPropertiesForAria(ariaProps: AriaProperties | AriaPropertiesWithId) {
    if (!ariaProps) {
        return null;
    }

    let domProperties = {};
    let ariaKeys = Object.keys(ariaProps);

    /* tslint:disable:no-string-literal */
    /* Can't access or assign 'aria-*' properties without string literals */
    for (let i = 0; i < ariaKeys.length; i++) {
        let key = ariaKeys[i];
        switch (key) {
            case 'role':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (28,17): Element implicitly has an 'any' type because expression of type '"role"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['role'] = ariaProps.role;
                break;
            case 'id':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (34,17): Element implicitly has an 'any' type because expression of type '"id"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['id'] = (<AriaPropertiesWithId>ariaProps).id;
                break;
            case 'activeDescendant':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (40,17): Element implicitly has an 'any' type because expression of type '"aria-activedescendant"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-activedescendant'] = ariaProps.activeDescendant;
                break;
            case 'atomic':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (46,17): Element implicitly has an 'any' type because expression of type '"aria-atomic"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-atomic'] = ariaProps.atomic;
                break;
            case 'autocomplete':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (52,17): Element implicitly has an 'any' type because expression of type '"aria-autocomplete"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-autocomplete'] = ariaProps.autocomplete;
                break;
            case 'busy':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (58,17): Element implicitly has an 'any' type because expression of type '"aria-busy"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-busy'] = ariaProps.busy;
                break;
            case 'checked':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (64,17): Element implicitly has an 'any' type because expression of type '"aria-checked"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-checked'] = ariaProps.checked;
                break;
            case 'controls':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (70,17): Element implicitly has an 'any' type because expression of type '"aria-controls"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-controls'] = joinListOfTokens(ariaProps.controls);
                break;
            case 'describedBy':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (76,17): Element implicitly has an 'any' type because expression of type '"aria-describedby"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-describedby'] = joinListOfTokens(ariaProps.describedBy);
                break;
            case 'disabled':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (82,17): Element implicitly has an 'any' type because expression of type '"aria-disabled"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-disabled'] = ariaProps.disabled;
                break;
            case 'dropEffect':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (88,17): Element implicitly has an 'any' type because expression of type '"aria-dropeffect"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-dropeffect'] = joinListOfTokens(ariaProps.dropEffect);
                break;
            case 'expanded':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (94,17): Element implicitly has an 'any' type because expression of type '"aria-expanded"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-expanded'] = ariaProps.expanded;
                break;
            case 'flowTo':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (100,17): Element implicitly has an 'any' type because expression of type '"aria-flowto"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-flowto'] = joinListOfTokens(ariaProps.flowTo);
                break;
            case 'grabbed':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (106,17): Element implicitly has an 'any' type because expression of type '"aria-grabbed"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-grabbed'] = ariaProps.grabbed;
                break;
            case 'hasPopup':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (112,17): Element implicitly has an 'any' type because expression of type '"aria-haspopup"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-haspopup'] = ariaProps.hasPopup;
                break;
            case 'hidden':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (118,17): Element implicitly has an 'any' type because expression of type '"aria-hidden"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-hidden'] = ariaProps.hidden;
                break;
            case 'invalid':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (124,17): Element implicitly has an 'any' type because expression of type '"aria-invalid"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-invalid'] = ariaProps.invalid;
                break;
            case 'label':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (130,17): Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-label'] = ariaProps.label;
                break;
            case 'labelledBy':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (136,17): Element implicitly has an 'any' type because expression of type '"aria-labelledby"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-labelledby'] = joinListOfTokens(ariaProps.labelledBy);
                break;
            case 'level':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (142,17): Element implicitly has an 'any' type because expression of type '"aria-level"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-level'] = ariaProps.level;
                break;
            case 'live':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (148,17): Element implicitly has an 'any' type because expression of type '"aria-live"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-live'] = ariaProps.live;
                break;
            case 'multiline':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (154,17): Element implicitly has an 'any' type because expression of type '"aria-multiline"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-multiline'] = ariaProps.multiline;
                break;
            case 'multiselectable':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (160,17): Element implicitly has an 'any' type because expression of type '"aria-multiselectable"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-multiselectable'] = ariaProps.multiselectable;
                break;
            case 'orientation':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (166,17): Element implicitly has an 'any' type because expression of type '"aria-orientation"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-orientation'] = ariaProps.orientation;
                break;
            case 'owns':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (172,17): Element implicitly has an 'any' type because expression of type '"aria-owns"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-owns'] = joinListOfTokens(ariaProps.owns);
                break;
            case 'positionInSet':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (178,17): Element implicitly has an 'any' type because expression of type '"aria-posinset"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-posinset'] = ariaProps.positionInSet;
                break;
            case 'pressed':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (184,17): Element implicitly has an 'any' type because expression of type '"aria-pressed"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-pressed'] = ariaProps.pressed;
                break;
            case 'readonly':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (190,17): Element implicitly has an 'any' type because expression of type '"aria-readonly"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-readonly'] = ariaProps.readonly;
                break;
            case 'relevant':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (196,17): Element implicitly has an 'any' type because expression of type '"aria-relevant"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-relevant'] = joinListOfTokens(ariaProps.relevant);
                break;
            case 'required':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (202,17): Element implicitly has an 'any' type because expression of type '"aria-required"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-required'] = ariaProps.required;
                break;
            case 'selected':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (208,17): Element implicitly has an 'any' type because expression of type '"aria-selected"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-selected'] = ariaProps.selected;
                break;
            case 'setSize':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (214,17): Element implicitly has an 'any' type because expression of type '"aria-setsize"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-setsize'] = ariaProps.setSize;
                break;
            case 'sort':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (220,17): Element implicitly has an 'any' type because expression of type '"aria-sort"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-sort'] = ariaProps.sort;
                break;
            case 'valueMax':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (226,17): Element implicitly has an 'any' type because expression of type '"aria-valuemax"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-valuemax'] = ariaProps.valueMax;
                break;
            case 'valueMin':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (232,17): Element implicitly has an 'any' type because expression of type '"aria-valuemin"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-valuemin'] = ariaProps.valueMin;
                break;
            case 'valueNow':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (238,17): Element implicitly has an 'any' type because expression of type '"aria-valuenow"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-valuenow'] = ariaProps.valueNow;
                break;
            case 'valueText':
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (244,17): Element implicitly has an 'any' type because expression of type '"aria-valuetext"' can't be used to index type '{}'.
                // @ts-expect-error
                domProperties['aria-valuetext'] = ariaProps.valueText;
                break;
        }
    }
    /* tslint:enable:no-string-literal */

    return domProperties;
}
